import styled from 'astroturf/react';
import { Popup } from 'src/components/Popup';

const AddChecklistPopup = styled(Popup)`
  width: 700px;
  left: calc(50% - 350px);
  padding: 20px 20px;
  transition: top 0.25s ease-in-out, max-height 0.25s ease-in-out;
  overflow: hidden;
  max-height: 70%;
  top: 15%;

  &.expanded {
    max-height: 95%;
    top: 10%;
  }

  [class*='enableBtn'] {
    background-color: var(--ph-orange-500) !important;
  }
`;

const PopupContent = styled('div')`
  padding-top: 1rem;
`;

const ActionButtonRow = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  transition: margin-top 0.25s ease-in-out;

  &.expanded {
    margin-top: 16rem;
  }
`;

export default {
  AddChecklistPopup,
  ActionButtonRow,
  PopupContent,
};

